import GlossaryDetailedScreenShader from "../../shaders/glossaryScreen/GlossaryDetailedScreenShader";
import GlossaryDetailedScreenContextualization from "./GlossaryDetailedScreenContextualization";

export default function GlossaryDetailedScreenContext({term}) {
    // Used in

    // BUILD
    return (
        <div className="bg-backgroundLight3 overflow-auto h-full relative px-[16px] pb-[16px] mt-[4px]">
            <GlossaryDetailedScreenShader />
            <GlossaryDetailedScreenContextualization contextualization={term.contextualization} />
        </div>
    );
}